import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, type IIconButtonProps } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import styles from './styles.module.scss'

export const CallMicPopUpOutgoingButton: FC<Partial<IIconButtonProps>> = observer((props) => {
  const store = useCallPopUpDefaultContext()
  const { handleShowMic, isMic, isMute, handleMute, isMicDisabled, innerRefTooltipCurrent } = store

  return (
    <div className={styles.wrap}>
      <IconButton
        size={'large'}
        color={'red'}
        variant={'custom'}
        active={isMute}
        disabled={isMicDisabled}
        ariaLabel={`CallMicPopUpOutgoingButton_${isMute ? 'unmute' : 'mute'}`}
        onClick={() => {
          handleMute()
        }}
        iconProps={{
          icon: isMute ? 'microphoneMute' : 'microphone',
        }}
        tooltipProps={{
          label: isMute ? 'Unmute' : 'Mute',
          placement: 'top',
          zIndex: ZIndex.OVERLAY_TOP_1,
          PopperProps: {
            popperOptions: {
              modifiers: [
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: innerRefTooltipCurrent,
                  },
                },
              ],
            },
          },
        }}
        iconCircleButtonProps={{
          iconProps: {
            icon: isMic ? 'chevronUp' : 'chevronDown',
          },
          onClick: () => {
            handleShowMic()
          },
        }}
        {...props}
      />
    </div>
  )
})
